import { IDataForObjectIsAccepted } from '../../../actions/userObject/profile/requestFetchUserProfile'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IDataForObjectIsAccepted,
): IUserObjectStore {
  return {
    ...state,
    profileRequest: {
      ...state.profileRequest,
      acceptedCount: ++state.profileRequest.acceptedCount,
      isLoading: false,
    },
    userObject: {
      ...state.userObject,
      profile: {
        ...state.userObject.profile,
        ...action.profile,
      },
    },
  }
}
